// extracted by mini-css-extract-plugin
module.exports = {"headerVideo":"VideoCall_headerVideo__LYTWs","videoTooltip":"VideoCall_videoTooltip__3eyiR","videoIcon":"VideoCall_videoIcon__XrpxN"};